import { render, staticRenderFns } from "./ListPaymentNoticeReport.vue?vue&type=template&id=bc1b3188&"
import script from "./ListPaymentNoticeReport.vue?vue&type=script&lang=js&"
export * from "./ListPaymentNoticeReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports